export const baseMutations = {
    saveExecutives(state, data) {
        state.executives = data.data.reverse()
    },
    saveEstates(state, data) {
        state.estates = data.data.reverse()
    },
    setCurrentExecutive(state, data) {
        state.currentExecutive = state.executives.find(executive => executive.slug == data)
    },
    saveHouses(state, data) {
        state.houses = data.data.reverse()
    },
    setCurrentHouse(state, data) {
        state.currentHouse = state.houses.find(house => house.slug == data)
    },
    saveSliders(state, data) {
        state.sliders = data.data
    },
    saveSiteData(state, data) {
        state.siteData = data.data && data.data[0]
    },
    subscribe(state, data) {
        state.subscribeResponse = data
        state.subscribeStatus = false
    },
    saveBlogPosts(state, data) {
        state.articles = data.data
    },
    resetSubscribe(state) {
        state.subscribeResponse = ''
    },
    savePrivacy(state, data) {
        state.privacyContent = data.data
    },
    setSubscribeStatus(state, data) {
        state.subscribeStatus = data
    },
    setCurrentArticle(state, data) {
        state.currentArticle = state.articles.find(article => article.slug == data)
    },
    setLoadingState(state, data) {
        state.loadingState = data
    },
}